if (process.env.VUE_APP_GOOGLE_ANALYTIC) {
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-C88BZESH74');
}else{
    console.log("NO SCRIPT")
}
